// most
export const hallerPositions = [
  {
    position: [46.9485603, 7.4812098],
    displayName: "Schosshalde",
    imgSrc: ""
  },
  {
    position: [46.950213, 7.438846],
    displayName: "Grosse Schanze",
    imgSrc: require("images/haller-item.jpg")
  },
  {
    position: [46.947189, 7.443378],
    displayName: "Hauptsitz BEKB",
    imgSrc: require("images/haller-bekb.jpg")
  },
  {
    position: [46.953376, 7.445157],
    displayName: "Botanischer Garten",
    imgSrc: require("images/haller-boga.jpg")
  },
  {
    position: [46.967326, 7.397653],
    displayName: "Ethologische Station",
    imgSrc: ""
  }
  // {
  //   position: [46.857879, 7.564182],
  //   displayName: "Wichtrach",
  //   imgSrc: ""
  // }
];

export const kocherPositions = [
  {
    position: [46.946377, 7.432594],
    displayName: "Kocherpark",
    imgSrc: require("images/kocher-kocherpark.jpg")
  },
  {
    position: [46.948364, 7.422136],
    displayName: "Inselspital",
    imgSrc: require("images/kocher-inselspital.jpg")
  }
];

export const bubenbergPositions = [
  {
    position: [46.946945, 7.437916],
    displayName: "Bubenbergplatz",
    imgSrc: ""
  }
];

// moved
export const erlachPositions = [
  {
    position: [46.949187, 7.448132],
    displayName: "Ringgepark",
    imgSrc: require("images/erlach-ringgenpark.jpg")
  }
  // ,
  // {
  //   position: [46.946935, 7.451811],
  //   displayName: "Münsterplatz",
  //   imgSrc: ""
  // }
];

// export const gotthelfPositions = [
//   {
//     position: [46.95194, 7.460366],
//     displayName: "Rosengarten",
//     imgSrc: require("images/gotthelf_rosengarten.jpg")
//   }
// ];

export const zähringerPositions = [
  {
    position: [46.9486295, 7.4565782],
    displayName: "Nydegg-Hof",
    imgSrc: require("images/zähringer-nydegg.jpg")
  }
];

// headless
export const weinzäpfliPositions = [
  {
    position: [46.946563, 7.451874],
    displayName: "Münsterplattform",
    imgSrc: require("images/weinzaepfli-far.jpg")
  }
];

// export const wehrmännerPositions = [
//   {
//     displayName: "Engestrasse",
//     position: [46.963273, 7.440646],
//     imgSrc: require("images/wehrmaenner-close.jpg")
//   }
// ];

export const aargauerstaldenPositions = [
  {
    position: [46.952389, 7.458681],
    displayName: "Aargauerstalden",
    imgSrc: require("images/aargauerstalden-close.jpg")
  }
];

// eslint-disable-next-line @typescript-eslint/camelcase
export const vonwerdtPositions = [
  {
    position: [46.949648, 7.459048],
    displayName: "Klösterlistutz",
    imgSrc: require("images/von-werdt-close.jpg")
  }
];

// eslint-disable-next-line @typescript-eslint/camelcase
export const von_tavelPositions = [];

// natural
export const koppPositions = [
  {
    position: [46.94025, 7.447222],
    displayName: "Bundesarchiv",
    imgSrc: require("images/kopp-eiche-far.jpg")
  }
];

// export const kuenziPostitions = [
//   { position: [46.933222, 7.467806], displayName: "Elfenau" }
// ];

// export const studerPositions = [
//   {
//     position: [46.962194, 7.434111],
//     displayName: "Neufeld",
//     imgSrc: require("images/studer-stein-far.jpg")
//   }
// ];

// world
export const bolivarPositions = [
  {
    position: [46.939019, 7.472457],
    displayName: "Weltpost",
    imgSrc: ""
  }
];

export const rizalPositions = [
  {
    position: [46.948669, 7.440861],
    displayName: "Schweizerhof",
    imgSrc: ""
  }
];

// export const titulescuPositions = [
//   {
//     position: [46.940142, 7.456503],
//     displayName: "Rumänische Botschaft",
//     imgSrc: ""
//   }
// ];

export const leninPositions = [
  {
    position: [46.954233, 7.431974],
    displayName: "Lenin-Haus, Länggasse",
    imgSrc: ""
  }
];

export const mazziniPositions = [
  {
    position: [46.939252, 7.461528],
    displayName: "Italienische Botschaft",
    imgSrc: ""
  }
];

export const refugiantenPositions = [
  {
    position: [46.94894, 7.446643],
    displayName: "Französische Kirche",
    imgSrc: ""
  }
];

// modern
export const korenhuisbrugPositions = [
  {
    position: [46.949528, 7.447944],
    displayName: "Korenhuisbrug/Kornhausbrücke",
    imgSrc: "images/korenhuisbrug-far.jpg"
  }
];

export const stadionuhrPositions = [
  {
    position: [46.96181, 7.465364],
    displayName: "Wankdorf-Stadion",
    imgSrc: "images/stadionuhr-far.jpg"
  }
];

export const dankPositions = [
  {
    position: [46.945611, 7.422667],
    displayName: "Inselspital",
    imgSrc: ""
  }
];

export const einsteinPositions = [
  {
    displayName: "Rosengarten",
    position: [46.950639, 7.460583],
    imgSrc: require("images/einstein-rosengarten-close.jpg")
  },
  { displayName: "Bärengraben", position: [46.9475, 7.459472] },
  { displayName: "Uni-Hauptgebäude", position: [46.950222, 7.437944] },
  {
    displayName: "Historisches Museum",
    position: [46.943167, 7.449222]
  }
];

export const wagnerPositions = [];

// women
export const weltpostPositions = [
  {
    displayName: "Kleine Schanze",
    // to do: adjust
    position: [46.945871, 7.440295]
  }
];

export const telegraphenPositions = [
  {
    displayName: "Helvetiaplatz",
    // to do adjust
    position: [46.943774, 7.449085]
  }
];

export const minervaPositions = [
  {
    displayName: "Wasserschloss Thunplatz",
    // to do: adjust
    position: [46.940278, 7.458951]
  }
];

export const seilerPositions = [
  {
    displayName: "Anna-Seiler-Haus, Inselspital",
    // to do: adjust
    position: [46.945736, 7.420814]
  }
];
